var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurbujaChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 682,
    height: 741,
    viewBox: "0 0 682 741",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.99 461.787C674.214 424.242 682 383.53 682 341C682 152.671 529.329 0 341 0C152.671 0 0 152.671 0 341C0 529.329 152.671 682 341 682C364.107 682 386.676 679.702 408.493 675.321C408.203 692.932 398.759 719.341 394 730.5C389.6 742.5 401.833 740.833 408.5 738.5C580.1 670.1 648.667 523.333 661.5 458.5C660.998 459.602 660.494 460.698 659.99 461.787ZM546.189 613.382C543.008 615.781 539.784 618.127 536.518 620.417C539.721 618.193 542.946 615.851 546.189 613.382Z",
    fill: "#7DB8F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 469,
    r: 28,
    fill: "#1B212B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 359,
    cy: 469,
    r: 28,
    fill: "#1B212B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 469,
    r: 28,
    fill: "#1B212B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurbujaChat);
export default __webpack_public_path__ + "static/media/burbuja-chat.9c620f5139f009443cabf4e55e6b71f0.svg";
export { ForwardRef as ReactComponent };